import { useContext, useEffect, useState } from "react";
import Api from "./api/api";
import { AppContext } from "../App";
import jwt_decode from "jwt-decode";
import logo from "./../images/logo.png";

function Login() {
	const { user, setUser } = useContext(AppContext);
	const [shops, setShops] = useState([]);
	const [shopId, setShopId] = useState("");

	useEffect(() => {
		loadShops();
	}, []);

	async function loadShops() {
		const response = await Api.post("/shops/list/", {
			orderby: "position",
			fields: ["id", "name", "license_expires_at"],
			depth: 0,
			src: [{ name: "active", value: 1, compare: "equal" }],
		});
		const rows = response.rows || [];
		setShops(rows);
		const saved = rows.find((s) => s.id == localStorage.getItem("tracking-shop-id"));
		if (saved && !saved.license_expired) setShopId(String(saved.id));
		else if (rows.length === 1 && !rows[0].license_expired) setShopId(String(rows[0].id));
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		const data = new FormData(e.target);
		let request = Object.fromEntries(data.entries());
		delete request.shop_id;
		const login = await Api.login(request);
		if (login.success == 0) alert(login.error);
		else {
			const decoded = jwt_decode(login.token);
			localStorage.setItem("pos-user", login.token);
			const response = await Api.getProtected("/users/get/" + decoded.user_id + "/");
			if (response.success == 0) alert(response.error);
			else {
				// il negozio scelto deve essere tra quelli abilitati per l'operatore
				const allowed = await Api.postProtected("/tracking/shops/", { user_id: response.data.id });
				if (allowed.success == 0 || !(allowed.rows || []).find((s) => s.id == shopId)) {
					localStorage.removeItem("pos-user");
					alert("Operatore non abilitato al negozio selezionato");
				} else {
					localStorage.setItem("tracking-shop-id", shopId);
					setUser(response.data);
				}
			}
		}
	};

	return (
		<div className="login">
			<form className="content" onSubmit={handleSubmit}>
				<div className="login-logo"><img src={logo} /></div>
				<h2>Tracking Manager</h2>
				<select name="shop_id" value={shopId} onChange={(e) => setShopId(e.target.value)} required>
					<option value="">Seleziona il negozio</option>
					{shops.map((s) => (
						<option key={s.id} value={s.id} disabled={!!s.license_expired}>
							{s.name}
							{s.license_expired ? " (licenza scaduta)" : ""}
						</option>
					))}
				</select>
				<input type="email" name="email" autoComplete="username" placeholder="Email" />
				<input type="password" name="password" autoComplete="current-password" placeholder="Password" />
				<button className="button button-1">Accedi</button>
			</form>
		</div>
	);
}

export default Login;
